import { Directive, effect, ElementRef, inject, input } from '@angular/core';
import { FlipService } from '../../services/flip.service';

const animationDuration = 300; // milliseconds

@Directive({
  selector: '[appFlipItem]',
})
export class FlipItemDirective {
  private flipService = inject(FlipService);
  private el = inject(ElementRef) as ElementRef<HTMLElement>;

  id = input.required<string>();
  position = input.required<number>();

  constructor() {
    effect(() => {
      const position = this.position();
      const id = this.id();
      if (!id) return;

      const oldPosition = this.flipService.positions.get(id);
      this.flipService.positions.set(id, position);

      if (oldPosition !== undefined && oldPosition !== position) {
        this.animate(oldPosition, position);
      }
    });
  }

  private animate(from: number, to: number) {
    const parent = this.el.nativeElement.parentElement;
    const oldItem = parent.querySelector(`[appFlipItem]:nth-child(${from + 1})`) as HTMLElement;

    const spacingOffset = from === 0 || to === 0 ? 20 : 0;
    const heightOfOldItem = oldItem.offsetHeight - spacingOffset;

    const scale = from > to ? 1 : -1;
    this.el.nativeElement.style.transform = `translateY(${heightOfOldItem * scale}px)`;

    requestAnimationFrame(() => {
      this.el.nativeElement.style.transition = `transform ${animationDuration / 1000}s ease-in`;
      this.el.nativeElement.style.transform = 'translateY(0)';
      setTimeout(() => {
        this.el.nativeElement.style.transition = '';
        this.el.nativeElement.style.transform = '';
      }, animationDuration);
    });
  }
}
